import request from '@/utils/request'


// 查询城市区域列表
export function listArea(query) {
  return request({
    url: '/user/area/list',
    method: 'get',
    params: query
  })
}

// 查询城市区域分页
export function pageArea(query) {
  return request({
    url: '/user/area/page',
    method: 'get',
    params: query
  })
}

// 查询城市区域详细
export function getArea(data) {
  return request({
    url: '/user/area/detail',
    method: 'get',
    params: data
  })
}

// 新增城市区域
export function addArea(data) {
  return request({
    url: '/user/area/add',
    method: 'post',
    data: data
  })
}

// 修改城市区域
export function updateArea(data) {
  return request({
    url: '/user/area/edit',
    method: 'post',
    data: data
  })
}

// 删除城市区域
export function delArea(data) {
  return request({
    url: '/user/area/delete',
    method: 'post',
    data: data
  })
}
